import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { Button,  ThemeProviderV2} from '@blueprint/ui';
import { useModal } from "react-modal-hook";
import { useHistory } from "react-router-dom";

import projectApi from "../../../api/project";
import { Loader, toast } from "../../../common/components/core";
import { useAuthErrorHandlerCreator } from "../../../common/hooks";
import { Handler } from "../../../types/common";
import { BesuProjectState } from "../../../types/project";
import {
    composeErrorHandlers,
    GenericError,
    onStaleStateError,
} from "../../../utils/errorHandling";

const useDeleteProjectHandler = (
    projectRef: string,
    project: BesuProjectState,
): Handler => {
    const history = useHistory();
    const [isSubmitting, setSubmitting] = useState(false);
    const onAuthError = useAuthErrorHandlerCreator();

    const [show, hide] = useModal(() => {
        const confirm = async () => {
            setSubmitting(true);
            try {
                await projectApi.delete(projectRef);
                toast(`Project '${project.name}' deleted`);
                history.push("/project");
            } catch (e) {
                setSubmitting(false);
                composeErrorHandlers(
                    onStaleStateError(() => {
                        history.push("/project");
                        toast("Page has been updated by another user.");
                    }),
                    onAuthError,
                )(e as GenericError);
            }
        };

        return (
            <ThemeProviderV2>
            <Modal show onHide={hide} backdrop="static" centered>
                <Loader overlay isLoading={isSubmitting}>
                    <Modal.Header>
                        <h2 className="mb-0">Delete Project</h2>
                    </Modal.Header>
                    <Modal.Body>
                        <p>Are you sure you want to delete this project?</p>
                    </Modal.Body>

                    <Modal.Footer className="d-flex justify-content-between px-3">
                        <Button variant="light.tertiary" onClick={hide}>
                            Cancel
                        </Button>
                        <Button variant="light.primary" onClick={confirm}>
                            Confirm
                        </Button>
                    </Modal.Footer>
                </Loader>
            </Modal>
            </ThemeProviderV2>
        );
    }, [projectRef, project, isSubmitting, onAuthError]);

    return {
        isSubmitting,
        handler: show,
    };
};

export default useDeleteProjectHandler;
